export default function PHP_strncasecmp() {
  return (
    <div>
      <h1>PHP_strncasecmp</h1>
    </div>
  );
}
